<template>
  <View gap="md" direction="column">
    <View gap="sm" direction="column">
      <Text variant="label-medium" color="tertiary">{{ employment.type }}</Text>
      <Text variant="body-medium">{{ date }}</Text>
      <Text variant="body-medium">{{ employment.jobTitle }}</Text>
      <Text variant="body-medium">{{ employment.companyName }}</Text>
      <Text variant="body-medium">{{ netIncome }} net</Text>
    </View>

    <View
      gap="sm"
      direction="column"
      v-if="employment.managerName || employment.managerPhone || employment.managerEmail"
    >
      <Text variant="label-medium" color="tertiary">Manager contact</Text>
      <Text variant="body-medium" v-if="employment.managerName">{{ employment.managerName }}</Text>
      <Text variant="body-medium" v-if="employment.managerPhone">
        {{ employment.managerPhone }}
      </Text>
      <Text variant="body-medium" v-if="employment.managerEmail">
        {{ employment.managerEmail }}
      </Text>
    </View>
  </View>
</template>

<script setup lang="ts">
import { useDateFormat } from '@vueuse/core';
import { computed } from 'vue';

import { formatCurrency, Text, View } from '@tallo/design-system';

import { ApplicationEmploymentInfoDto } from '../../interfaces/employment.interface';

const props = defineProps<{ employment: ApplicationEmploymentInfoDto }>();
const netIncome = computed(() => (props.employment.netIncome ? formatCurrency(props.employment.netIncome) : null));
const date = computed(() => {
  const startDate = useDateFormat(props.employment.startDate!, 'MMM YYYY').value;
  const endDate = props.employment.endDate ? useDateFormat(props.employment.endDate, 'MMM YYYY').value : 'Current';

  return `${startDate} - ${endDate}`;
});
</script>

<style scoped lang="scss"></style>
